export default "__VITE_ASSET__DCZ$4G9i__"